export default "__VITE_ASSET__d_TQ5xfJ__"